
import { mapState } from 'vuex';

export default {
  i18nComponentKey: 'ReviewPrompt.components.SingleReviewBody',
  name: 'SingleReviewBody',
  props: {
    subOrder: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('window', ['windowService']),
    showSubBrandName() {
      return (
        this.reviewSettings.use_sub_brand_filter_setting &&
        this.subOrder.product.sub_brand_name
      );
    },
    endDate() {
      if (!this.subOrder.pending_review_expires_in) return;

      return this.$t('pending_review.end_date', {
        end_date: this.subOrder.pending_review_expires_in,
        remaining_days: this.subOrder.remaining_days
      });
    },
    showProductOptions() {
      return (
        this.reviewSettings.show_options &&
        !!this.subOrder.product_options &&
        Object.keys(this.subOrder.product_options).length > 0
      );
    },
    productOptions() {
      return this.$t('pending_review.product_options', {
        product_options: Object.values(this.subOrder.product_options).join(
          ' ・ '
        )
      });
    }
  }
};
